import { createContext } from 'react';

export interface UserInfo {
  userId: string;
  name: string;
  admin: boolean;
  memberOfAccount: boolean;
  canManage: boolean;
  avochatoRep: boolean;
  canCall: boolean;
  lastUsedFilter: Record<string, string>;
  email: string;
  inboxEnabled: boolean;
  onboarding: Array<Record<string, any>>;
}

export const UserInfoContext = createContext<UserInfo>({
  userId: null,
  name: null,
  admin: null,
  memberOfAccount: null,
  canManage: null,
  avochatoRep: null,
  canCall: null,
  lastUsedFilter: null,
  email: null,
  inboxEnabled: null,
  onboarding: null,
});
